import { render } from "./JoinTheTripleTExperience.vue?vue&type=template&id=4d8c15bb"
import script from "./JoinTheTripleTExperience.vue?vue&type=script&lang=js"
export * from "./JoinTheTripleTExperience.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__